import {
  formatDistanceToNow,
  intlFormat,
  parseISO,
} from 'date-fns'
import { TimeHTMLAttributes, useEffect, useState } from 'react'
import { DURATION_DAY } from '@pogokid/util/datetime'

export interface RelativeDateDisplayProps
  extends TimeHTMLAttributes<HTMLElement> {
  /**
   * The date or time to display as an ISO
   * string
   *
   * eg: 2020-01-01T10:00
   */
  isoDateTime: string
  /**
   * Number of milliseconds after which the
   * date should be displayed as an absolute
   * date instead of a relative one
   *
   * Set to 0 to disable
   */
  absoluteAfter?: number
  formatOptions?: Parameters<typeof intlFormat>[1]
  locale?: string
}

export function RelativeDateDisplay({
  isoDateTime,
  absoluteAfter = 2 * DURATION_DAY,
  formatOptions,
  locale = 'en-GB',
  ...props
}: RelativeDateDisplayProps) {
  const [display, setDisplay] = useState('')
  useEffect(() => {
    const date = parseISO(isoDateTime)
    if (
      absoluteAfter &&
      Date.now() - date.getTime() > absoluteAfter
    ) {
      setDisplay(
        intlFormat(date, formatOptions ?? {}, { locale })
      )
    } else {
      setDisplay(formatDistanceToNow(date, { addSuffix: true }))
    }
  }, [absoluteAfter, formatOptions, isoDateTime, locale])
  return (
    <time dateTime={isoDateTime} title={isoDateTime} {...props}>
      {display}
    </time>
  )
}
